import { render, staticRenderFns } from "./fold3.vue?vue&type=template&id=0deb3c8f&scoped=true&"
import script from "./fold3.vue?vue&type=script&lang=js&"
export * from "./fold3.vue?vue&type=script&lang=js&"
import style0 from "./fold3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./fold3.vue?vue&type=style&index=1&id=0deb3c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb3c8f",
  null
  
)

export default component.exports